module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige7-e975b1a5d3250578ed2abdbc200f107b.jpg";